const ACTIVATION_FLOW_STARTED = 'Activation Flow Started';
const ACTIVATION_FLOW_SETUP_ACCOUNT_COMPLETED =
  'Activation Flow Setup Account Completed';
const ACTIVATION_FLOW_ADD_DATASOURCE_STARTED =
  'Activation Flow Add Datasource Started';
const ACTIVATION_FLOW_ADD_DATASOURCE_COMPLETED =
  'Activation Flow Add Datasource Completed';
const ACTIVATION_FLOW_ADD_DESTINATION_STARTED =
  'Activation Flow Add Destination Started';
const ACTIVATION_FLOW_ADD_DESTINATION_COMPLETED =
  'Activation Flow Add Destination Completed';
const ACTIVATION_FLOW_CREATE_REPORT_STARTED =
  'Activation Flow Create Report Started';
const ACTIVATION_FLOW_CREATE_REPORT_COMPLETED =
  'Activation Flow Create Report Completed';
const ACTIVATION_FLOW_VISIT_DASHBOARD_STARTED =
  'Activation Flow Visit Dashboard Started';
const ACTIVATION_FLOW_VISIT_DASHBOARD_COMPLETED =
  'Activation Flow Visit Dashboard Completed';

export const ACTIVATION_ANALYTICS_EVENTS = {
  ACTIVATION_FLOW_SETUP_ACCOUNT_COMPLETED,
  ACTIVATION_FLOW_ADD_DATASOURCE_COMPLETED,
  ACTIVATION_FLOW_ADD_DESTINATION_COMPLETED,
  ACTIVATION_FLOW_CREATE_REPORT_COMPLETED,
  ACTIVATION_FLOW_VISIT_DASHBOARD_COMPLETED,
  ACTIVATION_FLOW_STARTED,
  ACTIVATION_FLOW_ADD_DATASOURCE_STARTED,
  ACTIVATION_FLOW_ADD_DESTINATION_STARTED,
  ACTIVATION_FLOW_CREATE_REPORT_STARTED,
  ACTIVATION_FLOW_VISIT_DASHBOARD_STARTED,
};
